import { render, staticRenderFns } from "./yScrollYunsu.vue?vue&type=template&id=f0a532c6&"
import script from "./yScrollYunsu.vue?vue&type=script&lang=js&"
export * from "./yScrollYunsu.vue?vue&type=script&lang=js&"
import style0 from "./yScrollYunsu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports